import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { PROJECT_MEMBER_ROLE_ICONS, PROJECT_MEMBER_ROLES, ProjectMemberRole } from 'src/app/constants';
import { TenantUserRole, TENANT_USER_ROLES } from 'src/models/users';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';
import { AuthService } from 'src/services/auth.service';
import { MessageService } from 'src/services/message.service';
import { ProjectsService } from 'src/services/projects.service';
import { ServiceAccountsService } from 'src/services/service-accounts.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, SharedPipesModule, NgxTippyModule],
  selector: 'app-create-service-account',
  templateUrl: './create-service-account.component.html',
  styleUrls: ['./create-service-account.component.scss'],
})
export class CreateServiceAccountComponent implements OnInit {
  isLoading = false;
  name: string = '';
  role: TenantUserRole | ProjectMemberRole = this.authService.profile.role;
  projectId: string;

  ROLE_OPTIONS: { label: string; value: TenantUserRole | ProjectMemberRole; icon?: string }[] = [];

  constructor(
    private modalCtrl: ModalController,
    private msgSrvc: MessageService,
    private serviceAccountsService: ServiceAccountsService,
    public authService: AuthService,
    private projectsService: ProjectsService,
  ) {}

  ngOnInit() {
    this.ROLE_OPTIONS = (
      this.projectId
        ? [
            this.authService.isTenantOwner
              ? {
                  label: 'Owner',
                  value: PROJECT_MEMBER_ROLES.OWNER,
                  icon: PROJECT_MEMBER_ROLE_ICONS[PROJECT_MEMBER_ROLES.OWNER],
                }
              : undefined,
            {
              label: 'Agent',
              value: PROJECT_MEMBER_ROLES.AGENT,
              icon: PROJECT_MEMBER_ROLE_ICONS[PROJECT_MEMBER_ROLES.AGENT],
            },
            {
              label: 'Standard',
              value: PROJECT_MEMBER_ROLES.STANDARD,
            },
          ]
        : [
            this.authService.isTenantOwner
              ? {
                  label: 'Owner',
                  value: TENANT_USER_ROLES.OWNER,
                  icon: 'shield-checkmark-outline',
                }
              : undefined,
            {
              label: 'Admin',
              value: TENANT_USER_ROLES.ADMIN,
              icon: 'shield-outline',
            },
            {
              label: 'Standard',
              value: TENANT_USER_ROLES.STANDARD,
            },
          ]
    ).filter(Boolean);
  }

  async submit() {
    if (!this.name) {
      await this.msgSrvc.show('Whoops! Please enter a name.');

      return;
    }

    this.isLoading = true;

    try {
      const { token } = this.projectId
        ? await this.projectsService.createServiceAccount(this.projectId, {
            name: this.name,
            role: this.role as ProjectMemberRole,
          })
        : await this.serviceAccountsService.create({ name: this.name, role: this.role as TenantUserRole });

      await this.msgSrvc.show('Service account added!');

      this.dismiss(token);
    } catch (error) {
      await this.msgSrvc.showError(error);
    } finally {
      this.isLoading = false;
    }
  }

  dismiss(token?: string) {
    this.modalCtrl.dismiss(token);
  }
}
